import React from 'react'

const VersionSeparator = () => <div className="d-flex mt-4" />

export default VersionSeparator
